import React from 'react';

const IMG_URL = process.env.REACT_APP_BASE_IMAGE_URL || '';

type ImageProps = {
	src?: string;
	alt?: string;
	className?: string;
	style?: React.CSSProperties;
	zoomOnHover?: boolean;
};

const Image: React.FC<ImageProps> = ({
	src = '',
	alt = 'image',
	className = '',
	style = {},
	zoomOnHover = false,
}) => {
	const safeSrc =
		src || 'https://assets.webdads2u.com/images/1778042348274-image-not-found--1-.png';

	const imageSrc =
		safeSrc && (safeSrc.startsWith('http') || safeSrc.startsWith('blob:'))
			? safeSrc
			: safeSrc
				? `${IMG_URL.replace(/\/$/, '')}/${safeSrc.replace(/^\//, '')}`
				: 'https://assets.webdads2u.com/images/1778042348274-image-not-found--1-.png';

	const handleZoomIn = (
		e: React.MouseEvent<HTMLImageElement> | React.FocusEvent<HTMLImageElement>
	) => {
		if (zoomOnHover) {
			e.currentTarget.style.transform = 'scale(1.05)';
		}
	};

	const handleZoomOut = (
		e: React.MouseEvent<HTMLImageElement> | React.FocusEvent<HTMLImageElement>
	) => {
		if (zoomOnHover) {
			e.currentTarget.style.transform = 'scale(1)';
		}
	};

	const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
		e.currentTarget.src = '';
	};

	return (
		<img
			src={imageSrc}
			alt={alt}
			className={className}
			style={{
				transition: zoomOnHover ? 'transform 0.3s ease-in-out' : undefined,
				...style,
			}}
			onMouseOver={handleZoomIn}
			onMouseOut={handleZoomOut}
			onFocus={handleZoomIn}
			onBlur={handleZoomOut}
			onError={handleError}
		/>
	);
};

export default Image;
